function CHFrHomeBody() {
  return (
    <>
      <div className="container-fluid p-4 body-font">
        <div className="row">
          <div className="col-xs-12 col-md-6 py-md-5">
            <p className="h6">
              <b>L’autopartage simplifié</b>
            </p>
            <p className="h1">
              <b>Réservez. Montez.</b>
              <font className="text-warning">
                <b> Conduisez !</b>
              </font>
            </p>
            <p className="h6">
              Nous avons rendu la location avec Hertz 24/7® si simple et rapide
              que vous pouvez
              <br /> être dans votre véhicule en 15 minutes. <br />
            </p>
            <div className="row">
              <div className="col-xs-12 col-md-6" style={{ textAlign: "left" }}>
                <div className="row">
                  <div
                    className="col-xs-12 col-md-5"
                    style={{ textAlign: "left" }}
                  >
                    <a href="https://apps.apple.com/de/app/hertz-24-7-mobility/id6453605078">
                      <img
                        className="img-fluid"
                        src="https://images.hertz.com/content/dam/hod/images/en-gb/static/AppleAppStore.png"
                        alt=""
                        width={250}
                        style={{
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                        }}
                      />
                    </a>
                  </div>
                  <div
                    className="col-xs-12 col-md-1"
                    style={{ textAlign: "center" }}
                  >
                    &nbsp;
                  </div>
                  <div
                    className="col-xs-12 col-md-5"
                    style={{ textAlign: "left" }}
                  >
                    <a href="https://play.google.com/store/apps/details?id=com.hertz247.driverApp&hl=de_de&gl=de">
                      <img
                        className="img-fluid"
                        src="https://images.hertz.com/content/dam/hod/images/en-gb/static/GooglePlayStore.png"
                        alt=""
                        width={250}
                        style={{
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                        }}
                      />
                    </a>
                  </div>
                  <div
                    className="col-xs-12 col-md-1"
                    style={{ textAlign: "center" }}
                  >
                    &nbsp;
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-md-6"></div>
            </div>
          </div>
          <div className="col-xs-12 col-md-6" style={{ textAlign: "right" }}>
            <img
              className="img-fluid"
              src="https://images.hertz.com/content/dam/hod/images/en-gb/static/Mercedes_24sprinter_top.png"
              alt=""
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12" style={{ textAlign: "center" }}>
            <h1 className="display-5">
              <b>Comment ça fonctionne</b>
            </h1>
            <br />
            <p className="h6">
              Nous avons rendu la location avec Hertz 24/7® si simple et rapide
              que vous pouvez être dans votre véhicule en 15 minutes. Et voici
              comment ça fonctionne.
            </p>
            <br />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-md-3" style={{ textAlign: "center" }}>
            <img
              className="img-fluid"
              src="https://images.hertz.com/content/dam/hod/images/en-gb/static/QR_large.png"
              alt=""
            />
            <br />
            <br />
            <p className="h2">
              <b>01</b>
            </p>
            <br />
            <p className="h2">Télécharger l’application</p>
            <p>
              Vous pouvez télécharger rapidement et facilement l’application
              Hertz 24/7 depuis votre app store en scannant le code QR.
            </p>
          </div>
          <div className="col-xs-12 col-md-3" style={{ textAlign: "center" }}>
            <img
              style={{ width: "240px", borderRadius: "15px" }}
              className="img-fluid"
              src="https://images.hertz.com/content/dam/hod/images/de-de/static/247_DL_CH.png"
              alt=""
            />
            <br />
            <br />
            <p className="h2">
              <b>02</b>
            </p>
            <br />
            <p className="h2">Inscription</p>
            <p>
              Créez simplement votre profil de membre et soumettez vos documents
              pour vérification à l’aide de la fonction photo intégrée à
              l’application.
            </p>
          </div>
          <div className="col-xs-12 col-md-3" style={{ textAlign: "center" }}>
            <img
              style={{
                width: "260px",
                borderRadius: "15px",
                border: "1px solid #ccc",
              }}
              className="img-fluid"
              src="https://images.hertz.com/content/dam/hod/images/en-gb/static/Select_Location_CH.png"
              alt=""
            />
            <br />
            <br />
            <p className="h2">
              <b>03</b>
            </p>
            <br />
            <p className="h2">Réservez votre véhicule</p>
            <p>
              Connectez-vous à l’application et réservez votre véhicule en
              sélectionnant le lieu et l’heure de prise en charge souhaités.
              Vous aurez besoin d’une carte de crédit/débit.
            </p>
          </div>
          <div className="col-xs-12 col-md-3" style={{ textAlign: "center" }}>
            <img
              className="img-fluid"
              src="https://images.hertz.com/content/dam/hod/images/en-gb/static/Unlock.png"
              alt=""
            />
            <br />
            <br />
            <p className="h2">
              <b>04</b>
            </p>
            <br />
            <p className="h2">Démarrer la location</p>
            <p>
              Peu avant le début de votre location, un véhicule vous sera
              attribué. Lors de la prise en charge, vous recevrez la clé
              numérique dans l’application pour déverrouiller le véhicule.
            </p>
          </div>
        </div>

        <div className="row" style={{ backgroundColor: "#F3F3F3" }}>
          <div className="col-xs-12" style={{ textAlign: "center" }}>
            <br />
            <h1 className="display-5">
              <b>Notre flotte</b>
            </h1>
            <br />
            <p className="h6">
              Hertz 24/7® dispose du véhicule adapté à chaque occasion. Il vous
              suffit de choisir le véhicule qui vous convient et vous êtes prêt
              à prendre la route.
            </p>
            <br />
            <div className="row">
              <div
                className="col-xs-12 col-md-6"
                style={{ textAlign: "center" }}
              >
                <img
                  className="img-fluid"
                  src="https://images.hertz.com/content/dam/hod/images/en-gb/static/FordTransitLWB%20.png"
                  alt=""
                />
                <br /> <br />
                <div className="row">
                  <div
                    className="col-xs-12 col-md-4"
                    style={{ textAlign: "center" }}
                  ></div>
                  <div
                    className="col-xs-12 col-md-5"
                    style={{ textAlign: "center" }}
                  >
                    <div style={{ textAlign: "left" }}>
                      <p className="h2">Opel Movano</p>
                      <p className="h6">ou similaire</p>
                      <span>
                        <ul>
                          <li>Portes:4</li>
                          <li>
                            Espace de chargement : 1,8 x 1,8 x 3,5 m (H x L x P)
                          </li>
                        </ul>
                      </span>
                    </div>
                  </div>
                  <div
                    className="col-xs-12 col-md-3"
                    style={{ textAlign: "center" }}
                  ></div>
                </div>
              </div>
              <div
                className="col-xs-12 col-md-6"
                style={{ textAlign: "center" }}
              >
                <img
                  className="img-fluid"
                  src="https://images.hertz.com/content/dam/hod/images/en-gb/static/FordCustomSWB.png"
                  alt=""
                />
                <br /> <br />
                <div className="row">
                  <div
                    className="col-xs-12 col-md-4"
                    style={{ textAlign: "center" }}
                  ></div>
                  <div
                    className="col-xs-12 col-md-5"
                    style={{ textAlign: "center" }}
                  >
                    <div style={{ textAlign: "left" }}>
                      <p className="h2">Opel Vivaro</p>
                      <p className="h6">ou similaire</p>
                      <span>
                        <ul>
                          <li>Portes: 5</li>
                          <li>
                            Espace de chargement : 1,20 x 1,25 x 2,70 m (H x L x
                            P)
                          </li>
                        </ul>
                      </span>
                    </div>
                  </div>
                  <div
                    className="col-xs-12 col-md-3"
                    style={{ textAlign: "center" }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-md-6" style={{ textAlign: "center" }}>
            <img
              className="img-fluid"
              src="https://images.hertz.com/content/dam/hod/images/en-gb/static/Mobile_DE.png"
              alt=""
            />
          </div>
          <div
            className="col-xs-12 col-md-6 py-md-5"
            style={{ textAlign: "center" }}
          >
            <h1 className="display-5">
              <b>Nos agences</b>
            </h1>
            <p>
              Avec plus de 700 agences à travers l’Europe, un véhicule Hertz
              24/7® est plus proche que vous ne le pensez.
            </p>
            <div className="row">
              <div
                className="col-xs-12 col-md-4 "
                style={{ textAlign: "left" }}
              >
                <p>
                  <b>Royaume-Uni (300 Localisation des sites)</b>
                </p>
                <p>
                  <a
                    href="https://booking.hertz247.com/booking/book?location=prk-gb13121600020009&product=HOURLY_RENTAL"
                    style={{ textDecoration: "none" }}
                  >
                    Manchester
                  </a>
                </p>
                <p>
                  <a
                    href="https://booking.hertz247.com/booking/book?location=prk-gb11082902024006&product=HOURLY_RENTAL"
                    style={{ textDecoration: "none" }}
                  >
                    London
                  </a>
                </p>
              </div>
              <div
                className="col-xs-12 col-md-4 "
                style={{ textAlign: "left" }}
              >
                <p>
                  <b>France (20 Localisation des sites)</b>
                </p>
                <p>
                  <a
                    href="https://booking.hertz247.com/booking/book?location=prk-fr19100400001005&product=HOURLY_RENTAL"
                    style={{ textDecoration: "none" }}
                  >
                    Paris
                  </a>
                </p>
                <p>
                  <a
                    href="https://booking.hertz247.com/booking/book?location=prk-fr19110500007004&product=HOURLY_RENTAL"
                    style={{ textDecoration: "none" }}
                  >
                    Marseilles
                  </a>
                </p>
              </div>
              <div
                className="col-xs-12 col-md-4 "
                style={{ textAlign: "left" }}
              >
                <p>
                  <b>Allemagne (280 Localisation des sites)</b>
                </p>
                <p>
                  <a
                    href="https://booking.hertz247.com/booking/book?location=prk-de18112800001004&product=HOURLY_RENTAL"
                    style={{ textDecoration: "none" }}
                  >
                    Berlin
                  </a>
                </p>
                <p>
                  <a
                    href="https://booking.hertz247.com/booking/book?location=prk-de15102900001000&product=HOURLY_RENTAL"
                    style={{ textDecoration: "none" }}
                  >
                    Frankfurt
                  </a>
                </p>
              </div>
              <div
                className="col-xs-12 col-md-4 "
                style={{ textAlign: "left" }}
              >
                <p>
                  <b>Italie (75 Localisation des sites)</b>
                </p>
                <p>
                  <a
                    href="https://booking.hertz247.com/booking/book?location=prk-it17072800007000&product=HOURLY_RENTAL"
                    style={{ textDecoration: "none" }}
                  >
                    Rome
                  </a>
                </p>
                <p>
                  <a
                    href="https://booking.hertz247.com/booking/book?location=prk-it17072800005002&product=HOURLY_RENTAL"
                    style={{ textDecoration: "none" }}
                  >
                    Milan
                  </a>
                </p>
              </div>
              <div
                className="col-xs-12 col-md-4 "
                style={{ textAlign: "left" }}
              >
                <p>
                  <b>Portugal (39 Localisation des sites)</b>
                </p>
                <p>
                  <a
                    href="https://booking.hertz247.com/booking/book?location=prk-pt21051200001008&product=HOURLY_RENTAL"
                    style={{ textDecoration: "none" }}
                  >
                    Lisbon
                  </a>
                </p>
                <p>
                  <a
                    href="https://booking.hertz247.com/booking/book?location=prk-pt17062200003001&product=HOURLY_RENTAL"
                    style={{ textDecoration: "none" }}
                  >
                    Porto
                  </a>
                </p>
              </div>
              <div
                className="col-xs-12 col-md-4 "
                style={{ textAlign: "left" }}
              >
                <p>
                  <b>Suisse (4 Localisation des sites)</b>
                </p>
                <p>
                  <a
                    href="https://booking.hertz247.com/booking/book?location=prk-chCHHZBRN&product=HOURLY_RENTAL"
                    style={{ textDecoration: "none" }}
                  >
                    Bern
                  </a>
                </p>
                <p>
                  <a
                    href="https://booking.hertz247.com/booking/book?location=prk-chCHHZLUG&product=HOURLY_RENTAL"
                    style={{ textDecoration: "none" }}
                  >
                    Lugano
                  </a>
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12" style={{ textAlign: "left" }}>
                <b>
                  <u>Explorez les agences près de chez vous&gt;</u>
                </b>
                <br />
                <br />
              </div>
            </div>
            <div className="row">
              <div
                className="col-xs-12 col-md-6"
                style={{ textAlign: "right" }}
              >
                <div className="row">
                  <div
                    className="col-xs-12 col-md-5"
                    style={{ textAlign: "left" }}
                  >
                    <a href="https://apps.apple.com/de/app/hertz-24-7-mobility/id6453605078">
                      <img
                        className="img-fluid"
                        src="https://images.hertz.com/content/dam/hod/images/en-gb/static/AppleAppStore.png"
                        alt=""
                        width={250}
                      />
                    </a>
                  </div>
                  <div
                    className="col-xs-12 col-md-1"
                    style={{ textAlign: "center" }}
                  >
                    &nbsp;
                  </div>
                  <div
                    className="col-xs-12 col-md-5"
                    style={{ textAlign: "left" }}
                  >
                    <a href="https://play.google.com/store/apps/details?id=com.hertz247.driverApp&hl=de_de&gl=de">
                      <img
                        className="img-fluid"
                        src="https://images.hertz.com/content/dam/hod/images/en-gb/static/GooglePlayStore.png"
                        alt=""
                        width={250}
                      />
                    </a>
                  </div>
                  <div
                    className="col-xs-12 col-md-1"
                    style={{ textAlign: "center" }}
                  >
                    &nbsp;
                  </div>
                </div>
              </div>
              <div
                className="col-xs-12 col-md-6"
                style={{ textAlign: "left" }}
              ></div>
            </div>
          </div>
        </div>
        <div
          className="row p-4"
          style={{
            width: "100vw",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div
            className="row img-fluid"
            style={{
              backgroundImage:
                "url(https://images.hertz.com/content/dam/hod/images/en-gb/static/Transit_city.png)",
              backgroundSize: "cover",
            }}
          >
            <div className="col-xs-12 col-md-1"></div>
            <div className="col-xs-12 col-md-3">
              <br />
              <br />
              <br />
              <span>
                <h1 className="display-4">
                  <b>Pourquoi choisir Hertz 24/7® ?</b>
                </h1>
              </span>
              <p>
                Avec Hertz 24/7®, vous pouvez louer des véhicules à des tarifs
                avantageux, avec des prix à l’heure ou à la journée selon le
                type de véhicule et le lieu. Le prix estimé de votre location
                sera affiché au moment de la réservation*.
              </p>
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
            </div>
            <div className="col-xs-12 col-md-8"></div>
          </div>
        </div>

        <div className="row">
          <div
            className="col-xs-12 col-md-4"
            style={{ textAlign: "center", backgroundColor: "#fff7cc" }}
          >
            <br />
            <img
              className="img-fluid"
              src="https://images.hertz.com/content/dam/hod/images/en-gb/static/Contact.png"
              alt=""
            />
            <p className="h4">Service client</p>
            <p>
              Nous sommes disponibles pendant nos heures d’ouverture pour vous
              aider en cas de problème avec votre location ou le véhicule.
            </p>
          </div>
          <div
            className="col-xs-12 col-md-4 "
            style={{ textAlign: "center", backgroundColor: "#fff099" }}
          >
            <br />
            <img
              className="img-fluid"
              src="https://images.hertz.com/content/dam/hod/images/en-gb/static/Price.png"
              alt=""
            />
            <p className="h4">Tarification simple</p>
            <p>
              Réservez votre véhicule à l’heure ou à la journée. Utilisez les
              numéros de membre de nos partenaires pour bénéficier d’offres à
              tarif réduit.
            </p>
          </div>
          <div
            className="col-xs-12 col-md-4"
            style={{ textAlign: "center", backgroundColor: "#ffe866" }}
          >
            <br />
            <img
              className="img-fluid"
              src="https://images.hertz.com/content/dam/hod/images/en-gb/static/Location.png"
              alt=""
            />
            <p className="h4">Toujours à proximité</p>
            <p>
              Avec plus de 700 agences à travers l’Europe, il y a toujours un
              véhicule à proximité.
            </p>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12" style={{ textAlign: "center" }}>
            <br />
            <span>
              <h6>
                *Les tarifs au kilomètre peuvent varier selon le type de
                véhicule sélectionné.
              </h6>
            </span>
            <span>
              <h6>
                Veuillez toujours vérifier les tarifs kilométriques applicables
                au moment de votre réservation.
              </h6>
            </span>
          </div>
        </div>
      </div>
    </>
  );
}
export default CHFrHomeBody;
